var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInvoices(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#5E5E66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M6.62852 5.99567C6.22773 5.99567 5.90283 6.33109 5.90283 6.74485C5.90283 7.15862 6.22773 7.49404 6.62852 7.49404H12.7544C13.1552 7.49404 13.4801 7.15862 13.4801 6.74485C13.4801 6.33109 13.1552 5.99567 12.7544 5.99567H6.62852Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90298 9.94138C5.90298 9.52761 6.22788 9.19219 6.62867 9.19219H10.8192C11.22 9.19219 11.5449 9.52761 11.5449 9.94138C11.5449 10.3551 11.22 10.6906 10.8192 10.6906H6.62867C6.22788 10.6906 5.90298 10.3551 5.90298 9.94138Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3.5V15.9031L4.75746 16.2069C5.72632 15.2618 7.28418 15.2643 8.25 16.2142C9.2183 15.2618 10.7817 15.2618 11.75 16.2142C12.7158 15.2643 14.2737 15.2618 15.2425 16.2069L15.5 15.9031V3.5H4.5ZM4 2C3.44772 2 3 2.44772 3 3V16.0865C3 16.3233 3.08403 16.5524 3.23714 16.7331L3.98714 17.618C4.38655 18.0892 5.11345 18.0892 5.51286 17.618L5.73714 17.3533C6.13655 16.8821 6.86345 16.8821 7.26286 17.3533L7.48714 17.618C7.88655 18.0892 8.61345 18.0892 9.01286 17.618L9.23714 17.3533C9.63655 16.8821 10.3635 16.8821 10.7629 17.3533L10.9871 17.618C11.3865 18.0892 12.1135 18.0892 12.5129 17.618L12.7371 17.3533C13.1365 16.8821 13.8635 16.8821 14.2629 17.3533L14.4871 17.618C14.8865 18.0892 15.6135 18.0892 16.0129 17.618L16.7629 16.7331C16.916 16.5524 17 16.3233 17 16.0865V3C17 2.44772 16.5523 2 16 2H4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/invoices.dfe48acb.svg";
export { ForwardRef as ReactComponent };